/* jshint esversion: 6 */

export default class FancyboxGalleryDirective {

	constructor() {
		this.restrict = 'A';
	}

	link(scope, element, attributes, controller) {
		$('.fancybox', element).fancybox({
			closeBtn: false,
			hash: false, // Disabilita la modifica dell'URL
			touch: false,
			zoom: false,
			baseClass: 'fancybox-custom', // Aggiungi una classe base per identificare il fancybox
			afterLoad: function () {
				var $pin = this.$thumb.siblings('.label');

				if (!$pin.length) {
					return;
				}

				var _this = this;
				$pin.each(function (i, el) {
					_this.$content.append($(el).clone()[0]);
				});
			},
			afterClose: function () {
				history.pushState("", document.title, window.location.pathname + window.location.search);
			}
		}).addClass('fancyboxed');
		$('.anchor-link').on('click', function (e) {
			// e.preventDefault();

			var target = this.hash,
				$target = $(target);

			$('html, body').stop().animate({
				'scrollTop': $target.offset().top - 100
			}, 900, 'swing', function () {
			});

			// console.log(window.location);

			return false;
		});

	}

	static factory() {
		return new FancyboxGalleryDirective();
	}

}

FancyboxGalleryDirective.factory.$inject = [];
